import React from 'react';
import { ListItem, Paper, Avatar } from '@mui/material';
import RobotIcon from '@mui/icons-material/SmartToy';
import './TypingIndicator.css'; // Path to your CSS file

const TypingIndicator = ({ theme, message }) => {
    return (
      <div className="typing-indicator">
        {message}
        <span></span>
        <span></span>
        <span></span>
      </div>
    );
  };  

export default TypingIndicator;
